import { FC } from 'react';
import { ResourcesOption } from '../../types';
import ResourcesListItem from './ResourcesListItem';
import ResourceLink from './ResourceLink';
import Resource from './Resource';

interface ResourcesListProps {
  resourcesOptions: ResourcesOption[];
  onSelectOption: () => void;
}

const ResourcesList: FC<ResourcesListProps> = ({
  resourcesOptions,
  onSelectOption,
}) => {
  return (
    <ul role='menu' className='flex flex-col p-2' aria-label='Resources menu'>
      {resourcesOptions.map((option) => (
        <ResourcesListItem
          key={option.label}
          role='menuitem'
          aria-disabled={option.disabled}
          onSelectOption={() => {
            option.onClick?.();
            onSelectOption();
          }}
        >
          {option.isLink ? (
            <ResourceLink resourcesOption={option} />
          ) : (
            <Resource resourcesOption={option} />
          )}
        </ResourcesListItem>
      ))}
    </ul>
  );
};

export default ResourcesList;
